<template>
  <div class="px-3">
    <router-link
        v-if="demoData?.enabled" :to="{ name: 'settings' }"
        style="padding-right: 10px; padding-top: 4px; color: #ae940f; font-weight: bold;"
        class="block text-sm text-gray-200 hover:text-blue-950">
      DEMO
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'TopDemo',
  data() {
    return {
      demoData: null
    }
  },
  methods: {
    loadData: function () {
      console.log("load demo info")
      let c = this;
      c.demoData = null;
      c.loading = true;
      c.error = false;
      this.axios.get('/api/settings/account-demo').then(function(response) {
        console.log(response.data);
        c.demoData = response.data.data;
        c.loading = false;
      }).catch(function(err) {
        console.log(err.status);
        c.loading = false;
        c.error = true;
      });
    },
  },
  mounted() {
    this.loadData()
  }
}
</script>

<style scoped>

</style>